import { UI_CONSTANTS } from '../constants/ui'

export const getInitials = (name: string): string => {
  const trimmed = String(name || '').trim()

  if (!trimmed || trimmed === 'Unknown User') {
    return UI_CONSTANTS.AVATAR.UNKNOWN_USER_INITIALS
  }

  if (trimmed.startsWith('@')) {
    const localpart = trimmed.split(':')[0].slice(1)
    const phoneMatch = /^u(\d{10,15})$/.exec(localpart)
    if (phoneMatch) {
      return phoneMatch[1].slice(-2)
    }

    return localpart.slice(0, 2).toUpperCase()
  }

  const digitsOnly = trimmed.replace(/\D/g, '')
  if (digitsOnly.length >= 10 && digitsOnly.length >= trimmed.replace(/\s/g, '').length * 0.6) {
    return digitsOnly.slice(-2)
  }

  const parts = trimmed.split(/\s+/)

  if (parts.length === 1) {
    const word = parts[0]
    if (word.length <= UI_CONSTANTS.AVATAR.MIN_INITIALS_LENGTH) {
      return word
        .toUpperCase()
        .padEnd(
          UI_CONSTANTS.AVATAR.MIN_INITIALS_LENGTH,
          UI_CONSTANTS.AVATAR.INITIALS_PLACEHOLDER,
        )
    }
    return word.slice(0, 2).toUpperCase()
  }

  const [firstName, lastName] = parts

  const isValidName = (str: string, maxLength: number): boolean => {
    return str.length <= maxLength && !/^\d+$/.test(str)
  }

  if (
    isValidName(firstName, UI_CONSTANTS.AVATAR.MAX_FIRST_NAME_LENGTH)
    && isValidName(lastName, UI_CONSTANTS.AVATAR.MAX_LAST_NAME_LENGTH)
  ) {
    return (firstName[0] + lastName[0]).toUpperCase()
  }

  return (
    parts[0][0]
    + (parts[1]?.[0] || UI_CONSTANTS.AVATAR.INITIALS_PLACEHOLDER)
  ).toUpperCase()
}

/** @deprecated Используйте getInitials */
export const avatarText = getInitials

export const getAvatarColor = (name: string): string => {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }

  const colorIndex = (Math.abs(hash) % 8) + 1

  return `avatar-color-${colorIndex}`
}

export const avatarColors = [
  'avatar-color-1',
  'avatar-color-2',
  'avatar-color-3',
  'avatar-color-4',
  'avatar-color-5',
  'avatar-color-6',
  'avatar-color-7',
  'avatar-color-8',
] as const
